document.addEventListener("DOMContentLoaded", function () {
    let lastScrollTop = 0;
    const section = document.querySelector(".section.sticky"); // Select the section
    const scrollThreshold = 100; // Set the scroll threshold to 200px

    window.addEventListener("scroll", function () {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > lastScrollTop && scrollTop > scrollThreshold) {
            // Scrolling Down AND scrolled more than 200px - Hide Section
            section.classList.add("hide-section");
        } else {
            // Scrolling Up OR not scrolled enough - Show Section
            section.classList.remove("hide-section");
        }

        lastScrollTop = scrollTop;
    });
});